import {
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	EventEmitter,
	Injector,
	Input,
	OnInit,
	Output,
	ViewChild
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { ControlValueAccessorDirective } from '@shared/base-classes/control-value-accessor.directive';

let nextId = 0;

@Component({
	selector: 'rx-textarea',
	templateUrl: './rx-textarea.component.html',
	styleUrls: ['./rx-textarea.component.scss'],
	standalone: true,
	exportAs: 'rxTextarea',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [ReactiveFormsModule],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: RxTextareaComponent,
			multi: true
		}
	]
})
export class RxTextareaComponent extends ControlValueAccessorDirective<string | null> implements OnInit {
	@Input() placeholder = '';
	@Input() id?: string;
	@Input() rows = 1;
	@Input() label = 'rx-textarea-label';

	@Output() submitted = new EventEmitter<string | null>();
	@Output() cancelled = new EventEmitter<void>();

	@ViewChild('textareaInput') private readonly textareaInput?: ElementRef<HTMLTextAreaElement>;

	textareaId!: string;

	private committedValue: string | null = null;
	private committedValueInitialized = false;

	constructor(injector: Injector) {
		super(injector);
	}

	ngOnInit(): void {
		this.textareaId = this.id ?? `rx-textarea-${nextId++}`;
	}

	override writeValue(value: string | null): void {
		super.writeValue(value);
		if (!this.committedValueInitialized) {
			this.committedValue = value;
			this.committedValueInitialized = true;
		}
	}

	cancel(): void {
		this.control.setValue(this.committedValue);
		this.cancelled.emit();
	}

	submit(): void {
		this.committedValue = this.control.value;
		this.submitted.emit(this.control.value);
	}

	/** Refocus the composer; `rx-intuitive-notes` calls this via `@ViewChild` after posting a note. */
	focusInput(): void {
		const el = this.textareaInput?.nativeElement;
		el?.focus?.({ preventScroll: true });
	}
}
